import { useQueryClient, useMutation } from '@tanstack/react-query';
import { createUser, updateTenantUser, resendInviteLink } from "../orgPanelApiCalls";
import { key as getTenantUsers } from "../queries/useGetTenantUsersQuery";
import { useStore } from '../appStore';

const useInsertTenantUserMutation = () => {
    const orgId = useStore((state) => state.CurrentOrganizationId);
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (variables) => await createUser(orgId, variables.userAccountModel),
        onSuccess: (data, variables) => {
            queryClient.setQueryData([getTenantUsers, orgId], (previousData) => {
                // ensure we always return a valid array
                const safeData = Array.isArray(previousData) ? previousData : [];
                return [...safeData, data];
            });
        }
    })
}

const useUpdateTenantUserMutation = () => {
    const orgId = useStore((state) => state.CurrentOrganizationId);
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (variables) => await updateTenantUser(orgId, variables.userAccountUpdateModel),
        onSuccess: (data, variables) => {
            queryClient.setQueryData([getTenantUsers, orgId], (previousData) => {
                return [...previousData.filter((item) => item.accountId !== data.accountId), data];
            });
            queryClient.invalidateQueries([getTenantUsers, data.accountId, orgId]);
        }
    })
}
const useResendInviteLink = (userId) => {
    const orgId = useStore((state) => state.CurrentOrganizationId);
    return useMutation({
        mutationFn: async () => await resendInviteLink(orgId, userId),
    })
}

export { useInsertTenantUserMutation, useUpdateTenantUserMutation, useResendInviteLink };